import { useSelector } from 'react-redux';
import { PersonalConnection } from '../../types/misc';
import { RootState } from '../../redux/reducers';

export default function usePersonalConnections(): PersonalConnection[] {
  return useSelector((state: RootState) => state.user.connections);
}
